<template>
  <ReassuranceItem v-if="shouldDisplayCarriers">
    <template #icon>
      <IconLock v-if="isSimLocked" />
      <IconLockUnlocked v-if="!isSimLocked" />
    </template>
    <template #content>
      <div v-if="isSimLocked" class="flex">
        <div class="flex flex-col">
          <div class="body-2-bold">
            {{ i18n(translations.labelLock) }}
          </div>
          <RevLink @click="deployCarriersCompatibilityModal">
            <span class="caption">
              {{ i18n(translations.learnMoreLock) }}
            </span>
          </RevLink>
        </div>

        <div
          v-for="carrier in carriers"
          :key="carrier.name"
          class="border-static-default-low rounded-xs ml-8 h-24 h-[20px] border p-4"
        >
          <RevIllustration
            :alt="carrier.name"
            class="h-[20px] w-auto"
            :height="20"
            :src="carrier.logo"
            :width="60"
          />
        </div>

        <CarriersCompatibilityModal type="locked" />
      </div>

      <div v-if="!isSimLocked" class="flex flex-col items-baseline">
        <div class="body-2-bold">
          {{ i18n(translations.labelUnlock) }}
        </div>
        <RevLink @click="deployCarriersCompatibilityModal">
          <span class="caption">
            {{ i18n(translations.learnMoreUnlock) }}
          </span>
        </RevLink>
        <CarriersCompatibilityModal type="unlocked" />
      </div>
    </template>
  </ReassuranceItem>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { productAPI } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { isEmpty } from '@backmarket/utils/object/isEmpty'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'
import { openModal } from '@ds/components/ModalBase'
import { IconLock } from '@ds/icons/IconLock'
import { IconLockUnlocked } from '@ds/icons/IconLockUnlocked'

import { MODAL_NAMES } from '~/scopes/product/constants'

import CarriersCompatibilityModal from '../CarriersCompatibilityModal/CarriersCompatibilityModal.vue'
import ReassuranceItem from '../ReassuranceItem/ReassuranceItem.vue'

import translations from './ItemCarriers.translations'

const props = defineProps<{
  carriers: productAPI.GetProductResponse['compatibleCarriers']
}>()

const i18n = useI18n()
const { trackClick } = useTracking()

const shouldDisplayCarriers = computed(() => {
  return !isEmpty(props.carriers)
})

const isSimLocked = computed(() => {
  return props.carriers.some((carrier) => carrier.isSimLocked)
})

function deployCarriersCompatibilityModal() {
  trackClick({
    zone: 'carrier_compatibility',
    name: 'carrier_info',
  })
  openModal(MODAL_NAMES.CARRIERS_COMPATIBILITY)
}
</script>
